/**
 * Are the numbers a and b almost equal (by a maximum difference of maxDiff )
 * @param {number} a
 * @param {number} b
 * @param {number} maxDiff
 * @returns
 */
export function areNumbersAlmostEqual(a, b, maxDiff) {
  return Math.abs(a - b) < maxDiff;
}
